import { useRequest } from '@local-composable/request';

/**
 * 获取 API 基础 URL（根据环境变量）
 * @returns {string} API 基础 URL
 */
export function getApiBaseUrl() {
  // 根据链接判断：sandbox 和 localhost 使用测试服
  const hostname = window.location.hostname;
  const isTestEnv =
    hostname.includes('sandbox') || hostname === 'localhost' || hostname === '127.0.0.1';

  return isTestEnv ? 'https://sandbox-sellercrm.seeronnet.com' : 'https://sellercrm.seeronnet.com';
}

/**
 * 提交咨询表单
 * @param {Object} formData - 表单数据
 * @param {string} formData.name - 姓名
 * @param {string} [formData.contact] - 电话或电邮（合并字段）
 * @param {string} formData.countryCode - WhatsApp 区号（00格式，如 '00852'）
 * @param {string} formData.whatsapp - WhatsApp 号码
 * @param {string} [formData.question] - 咨询问题
 * @returns {Promise} 请求结果
 */
export async function submitConsultation(formData) {
  const { data, error } = await useRequest({
    url: `${getApiBaseUrl()}/v2/consultation`,
    data: {
      name: formData.name,
      whatsapp_area_code: formData.countryCode || '',
      whatsapp_number: formData.whatsapp || '',
      contact_info: formData.contact || '',
      inquiry_content: formData.question || '',
      teacher_name: '枫燧老师',
      site_id: '2',
    },
  }).post();

  return { data, error };
}
